module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/active_210715_01.png";